/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCreditNote = /* GraphQL */ `
  query GetCreditNote($id: ID!) {
    getCreditNote(id: $id) {
      id
      credit_note_number
      order_number
      customer_name
      delivery_date
      order_value
      credit_type
      reason
      comments
      at_fault
      status
      approved_by
      approved_at
      requested_at
      brand
      country
      folder
      created_by
      created_at
      updated_by
      updated_at
      line_items {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCreditNotes = /* GraphQL */ `
  query ListCreditNotes(
    $id: ID
    $filter: ModelCreditNoteFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCreditNotes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        credit_note_number
        order_number
        customer_name
        delivery_date
        order_value
        credit_type
        reason
        comments
        at_fault
        status
        approved_by
        approved_at
        requested_at
        brand
        country
        folder
        created_by
        created_at
        updated_by
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLineItem = /* GraphQL */ `
  query GetLineItem($id: ID!) {
    getLineItem(id: $id) {
      id
      creditNoteLine_itemsId
      credit_note {
        id
        credit_note_number
        order_number
        customer_name
        delivery_date
        order_value
        credit_type
        reason
        comments
        at_fault
        status
        approved_by
        approved_at
        requested_at
        brand
        country
        folder
        created_by
        created_at
        updated_by
        updated_at
        createdAt
        updatedAt
        __typename
      }
      sku
      item_name
      use_by_date
      quantity_ordered
      quantity_to_credit
      original_unit_price
      unit_price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLineItems = /* GraphQL */ `
  query ListLineItems(
    $id: ID
    $filter: ModelLineItemFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLineItems(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        creditNoteLine_itemsId
        sku
        item_name
        use_by_date
        quantity_ordered
        quantity_to_credit
        original_unit_price
        unit_price
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lineItemsByCreditNote = /* GraphQL */ `
  query LineItemsByCreditNote(
    $creditNoteLine_itemsId: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLineItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lineItemsByCreditNote(
      creditNoteLine_itemsId: $creditNoteLine_itemsId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creditNoteLine_itemsId
        sku
        item_name
        use_by_date
        quantity_ordered
        quantity_to_credit
        original_unit_price
        unit_price
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($order_number: String) {
    getOrder(order_number: $order_number) {
      order_number
      customer_name
      delivery_date
      order_value
      brand
      brand_country
      line_items {
        id
        sku
        item_name
        quantity
        gross_amount
        createdAt
        updatedAt
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
